// extracted by mini-css-extract-plugin
export var hackathonCountdown = "index-module--hackathonCountdown--2xqb6";
export var segments = "index-module--segments--2J_NC";
export var segment = "index-module--segment--2IyYc";
export var digit = "index-module--digit--1pR59";
export var label = "index-module--label--2y3me";